import React from "react";
import { Button, Form } from "react-bootstrap";
import _ from 'lodash';
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import { BRANDING } from "../../constants/Branding";
import "./BrandingPreivewForm.scss";

const BrandingPreviewForm = props => {
  const avatarUrl = _.get(props.cognitoUser, 'attributes["custom:avatar_thumbnail"]', BRANDING.AVATAR_FALLBACK_URL);

  return (
    <Form className="branding-preview-form">
      <div className="form-header">
        <img src={imgCamelLogo} alt="logo" />
        <button className="close-button" onClick={props.onClose}>×</button>
      </div>
      <div className="main-content">
        <div className="title">Sites Preview - {props.data.name}</div>
        <div className="preview-container">
          <div className="preview-page">
            <div className="branding-area">
              <div className="triangle-background">
                <div className="triangle1" style={{ borderTop: `100px solid ${props.data.color}` }} />
                <div className="triangle2" style={{ borderTop: `110px solid ${props.data.color}` }}/>
              </div>
              {props.data.logo && 
                <img className="branding-logo" src={props.data.logo} alt="branding logo" />
              }
            </div>
            <div className="items-area">
              <div className="site-header">
                {avatarUrl &&
                <div className="avatar">
                  <img src={avatarUrl} alt="avatar" />
                </div>
                }
                <div className="site-info">
                  <div className="site-title">Site Description</div>
                  {/* <div className="site-description">Site Description</div> */}
                </div>
              </div>
              <div className="items-container">
                <div className="item-container">
                  <div className="thumbnail-section" />
                  <div className="content-section" />
                </div>
                <div className="item-container">
                  <div className="thumbnail-section" />
                  <div className="content-section" />
                </div>
                <div className="item-container">
                  <div className="thumbnail-section" />
                  <div className="content-section" />
                </div>
                <div className="item-container">
                  <div className="thumbnail-section" />
                  <div className="content-section" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="actions-box">
        <Button
          onClick={props.onClose}
          variant="outline-primary"
          className="mr-2"
          size="sm"
        >
          Cancel
        </Button>
      </div>
    </Form>
  );
}

export default BrandingPreviewForm;
